/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alignOffsetRTL = exports.alignOffsetLTR = exports.alignPositionRTL = exports.alignPositionLTR = void 0;
var alignPositionLTR = ['tl-tr', 'bl-br', 'tr-tl', 'br-bl'];
exports.alignPositionLTR = alignPositionLTR;
var alignPositionRTL = ['tr-tl', 'br-bl', 'tl-tr', 'bl-br'];
exports.alignPositionRTL = alignPositionRTL;
var alignOffsetLTR = [{
  x: -7,
  y: 5
}, {
  x: -7,
  y: -5
}, {
  x: 7,
  y: 5
}, {
  x: 7,
  y: -5
}];
exports.alignOffsetLTR = alignOffsetLTR;
var alignOffsetRTL = [{
  x: 7,
  y: 5
}, {
  x: 7,
  y: -5
}, {
  x: -7,
  y: 5
}, {
  x: -7,
  y: -5
}];
exports.alignOffsetRTL = alignOffsetRTL;